<template>
    <div class="products">
        <div class="slider">
            <div class="item">
                <div class="container">
                    <div class="col-12 float-left"
                         style="margin-top:150px;margin-bottom:30px;">
                        <h1>{{ productCategoryName }}</h1>
                    </div>
                    <div class="col-12 col-md-8 offset-md-2 float-left">
                        <input type="text"
                               class="form-control rounded-pill"
                               placeholder="محصول مورد نظر خود را جستجو کنید..." />
                    </div>
                </div>
            </div>
        </div>
        <div class="container p-0">
            <div class="content">
                <div class="col-6 col-md-3 float-right mb-5 pr-2 pl-2"
                     v-for="(product,productIndex) in products" :key="productIndex">
                    <div class="item">
                        <div class="img"
                             v-bind:style="{'background-image':'url(' + rootImagePath + product.imagePath + ')'}"></div>
                        <div class="details">
                            <label class="name">{{ product.name }}</label>
                            <div class="price"
                                 v-bind:class="{ 'no-off': product.oldPrice == null }">
                                <div v-if="product.oldPrice != null" class="off">
                                    <span>
                                        {{new Intl.NumberFormat().format(product.oldPrice)}}
                                    </span>
                                    <span> ریال </span>
                                </div>
                                <div class="current">
                                    <span>
                                        {{new Intl.NumberFormat().format(product.price)}}
                                    </span>
                                    <span> ریال </span>
                                </div>
                            </div>
                        </div>
                        <router-link class="text-dark float-right d-block"
                                     :to="{ name: 'product', params:{ id: product.productId,  name: product.name.replace(/ /gi, '-') }}">
                            مشاهده محصول
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            rootImagePath: {
                type: String
            },

            productCategoryName: {
                type: String
            },

            products: {
                type: Array
            }
        }
    };
</script>
<style scoped>
    .products {
        width: 100%;
        min-height: 100%;
        height: auto;
        float: left;
        direction: rtl;
        text-align: center;
        background: #EAEDED;
    }

        .products .content {
            float: left;
            width: 100%;
            height: auto;
            margin-top: 30px;
        }

            .products .content .item {
                width: 100%;
                height: auto;
                min-height: 320px;
                overflow: hidden;
                position: relative;
                background: #fff;
                margin-bottom: 15px;
            }

                .products .content .item .img {
                    width: 100%;
                    height: 180px;
                    background-position: center center;
                    background-size: cover;
                    transition: all 0.6s;
                    position: relative;
                    float: right;
                    z-index: 10;
                }

                    .products .content .item .img::after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background: #292929;
                        transition: all 0.5s;
                        opacity: 0;
                    }

                .products .content .item:hover > .img::after {
                    opacity: 0;
                }

                .products .content .item .details {
                    float: right;
                    width: 100%;
                    position: absolute;
                    top: 190px;
                    left: 0;
                }

                    .products .content .item .details .name {
                        text-align: center;
                        width: 100%;
                        float: right;
                        font-weight: bold;
                        color: #292929;
                        padding: 10px;
                        font-size: 13px;
                    }

                    .products .content .item .details .price .current,
                    .products .content .item .details .price .off {
                        width: 50%;
                        float: right;
                    }

                    .products .content .item .details .price.no-off .current {
                        width: 100%;
                        text-align: center;
                    }

                    .products .content .item .details .price.no-off .off {
                        display: none;
                    }

                    .products .content .item .details .price .off label {
                        color: #999;
                    }

                        .products .content .item .details .price .off label:first-child {
                            text-decoration: line-through;
                        }

                .products .content .item a {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    background: #f5c842;
                    color: #fff;
                    text-align: center;
                    text-decoration: none;
                    height: 40px;
                    padding-top: 10px;
                }

    @media screen and (max-width: 425px) {
        .products {
            padding-bottom: 20px;
        }
    }

    .slider,
    .slider .item {
        width: 100%;
        float: left;
        height: 300px;
        min-height: 300px;
    }

    .slider {
        padding: 0 !important;
        margin-bottom: 0;
    }

        .slider .item {
            background: #292929;
        }

        .slider h1 {
            position: relative;
            text-align: center;
            color: #fff;
            font-size: 25px;
        }

    .section-title {
        width: 100%;
        text-align: center;
    }

        .section-title h2 {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
            padding-bottom: 20px;
            position: relative;
        }

            .section-title h2::before {
                content: "";
                position: absolute;
                display: block;
                width: 120px;
                height: 1px;
                background: #ddd;
                bottom: 1px;
                left: calc(50% - 60px);
            }

            .section-title h2::after {
                content: "";
                position: absolute;
                display: block;
                width: 40px;
                height: 3px;
                background: #d00918;
                bottom: 0;
                left: calc(50% - 20px);
            }

        .section-title p {
            margin-bottom: 0;
        }

        .section-title.light {
            color: #ddd;
        }
</style>
